import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: { data: {} },
    table: createTableState(),
    filterData: undefined,
    cashId: null,
})

const getters = {}

const actions = {
    async get({state, commit}, {cashId, page, filterData} = {}) {
        commit('setLoading', true)
        commit('updateTableData', [])

        if (cashId) state.cashId = cashId
        state.filterData = filterData

        const params = {
            page: page?.current,
            page_limit: page?.pageSize,
            ...(filterData || {}),
        }

        try {
            const res = await this._vm.axios.get(this._vm.endpoints['company_cash_movement'], {
                urlVars: { cashId: state.cashId },
                params,
            })
            const { data, meta } = res.data
            commit('updateTableData', data || [])
            if (meta) {
                commit('updatePagination', normalizePagination(meta))
            } else {
                const total = (data || []).length
                commit('updatePagination', { current: 1, pageSize: total || 1, total, sort: [] })
            }
        } finally {
            setTimeout(() => commit('setLoading', false), 250)
        }
    },

    async add({commit, dispatch}, {cashId, formData}) {
        try {
            const res = await this._vm.axios.post(
                this._vm.endpoints['company_cash_movement'],
                formData,
                { urlVars: { cashId } },
            )
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    refresh({dispatch, state}) {
        dispatch('get', { cashId: state.cashId, filterData: state.filterData })
    },
}

const mutations = {
    setLoading(state, val) { state.table.loading = val },
    updateTableData(state, data) { state.table.data = data },
    updatePagination(state, pagination) { state.table.pagination = pagination },
    updateSaveData(state, data) { state.save.data = data },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
